require('./e3-google-map.scss');
const detectBrowser = require('a_common-folder/utils/detectBrowser');

import EventEmitter from '../helpers/EventEmmiter';

const GoogleMapsLoader = require('google-maps'); // only for common js environments
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.VERSION = '3.37';

class E3GoogleMap  extends EventEmitter {
    constructor(key) {
        super(key);
        GoogleMapsLoader.KEY = key;

        this.mapDiv = null;
        this.panoDiv = null;
        this.inputDiv = null;
        this.containerDiv = null;
        this.defaultCoord = {lat: 51.509865, lng:  -0.118092};
        this.location = {latLng: {lat: () => 51.509865, lng: () => -0.118092}};
    }

    container() {
        const container = document.createElement('div');
        container.classList.add('google-map-container');

        const input = document.createElement('input');
        input.classList.add('controls');
        input.type = 'text';
        input.id = 'pac-input';
        input.placeholder = 'Search Box';

        const map = document.createElement('map');
        map.id = 'map';

        const pano = document.createElement('pano');
        pano.id = 'pano';

        const mapContainer = document.createElement('div');
        mapContainer.classList.add('map-container');
        const button = document.createElement('button');
        button.innerText = 'Choose';
        button.disabled = true;
        button.classList.add('google-map-button');
        button.classList.add('button');
        button.addEventListener('click', this.sendCoords.bind(this))

        container.appendChild(input);
        mapContainer.appendChild(map);
        mapContainer.appendChild(pano);
        container.appendChild(mapContainer);
        container.appendChild(button);

        this.buttonDiv = button;
        this.mapDiv = map;
        this.panoDiv = pano;
        this.inputDiv = input;

        this.initialize();

        this.containerDiv = container;

        return container;
    }

    close(){
        this._fireEvent('e3.google.street.close', null);
    }

    sendCoords(){
        const {heading, pitch} = this.panorama.getPov();
        const zoom = 0;

        const street  = `https://www.google.com/maps/embed?pb=!4v1566387696657!6m8!1m7!1s${this.location.pano}!2m2!1d0!2d0!3f${heading}!4f${pitch}!5f${zoom}`;
        // const street  = `https://www.google.com/maps/embed/v1/streetview?key=${GoogleMapsLoader.KEY}&pano=${this.location.pano}&heading=${heading}&pitch=${pitch}`;
        const map  = encodeURI(`https://www.google.com/maps?q=${this.ddToDms(this.location.latLng.lat(), this.location.latLng.lng())}&data=!3m8!1e1&output=embed`);
        // const map  = `https://maps.google.com/maps?q=${this.location.latLng.lat()},${this.location.latLng.lng()}&hl=es;z=14&output=embed`;

        this._fireEvent('e3.google.street', {street, map});
    }

    ddToDms(lat, lng) {
        let latResult,
            lngResult,
            dmsResult,
            latFin,
            lngFin;

        lat = parseFloat(lat);
        lng = parseFloat(lng);

        latResult = (lat >= 0)? 'N' : 'S';
        latFin = `${this.getDms(lat)}${latResult}`;
        lngResult = (lng >= 0)? 'E' : 'W';
        lngFin = `${this.getDms(lng)}${lngResult}`;
        dmsResult = latFin + ' ' + lngFin;

        return dmsResult;
    }

    getDms(val) {

        var valDeg, valMin, valSec, result;

        val = Math.abs(val);

        valDeg = Math.floor(val);
        result = valDeg + "°";

        valMin = Math.floor((val - valDeg) * 60);
        result += valMin + "'";

        valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
        result += valSec + '"';

        return result;
    }

    getLocation() {
        return new Promise((req, res) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.defaultCoord =  {lat: position.coords.latitude, lng:  position.coords.longitude};
                    req();
                }, () => {
                    req();
                });
            }else{
                req();
            }
        })
    }

    initialize(){
        this.getLocation().then(() => {
            GoogleMapsLoader.load((google) => {
                this.map = new google.maps.Map(this.mapDiv , {
                    center: this.defaultCoord,
                    zoom: 14,
                    draggableCursor: "crosshair",
                    minZoom: 2,
                    zoomControl: !1,
                    streetViewControl:  true,
                    streetViewControlOptions: {
                        position: 1
                    },
                    mapTypeControl: !1,
                    clickableIcons: !1,
                    fullscreenControl: !1,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                });

                const SVlayer = new google.maps.StreetViewCoverageLayer();
                SVlayer.setMap(this.map);

                this.sv = new google.maps.StreetViewService();

                google.maps.event.addListener(this.map, "tilesloaded", (event) => {
                    this.initSearchBox(google);
                    this.inputDiv.style.display = 'inline-block';
                    setTimeout(() => this.inputDiv.focus(), 100)
                })

                google.maps.event.addListener(this.map, "click", (event) => {
                    var latitude = event.latLng.lat();
                    var longitude = event.latLng.lng();
                    console.log( latitude + ', ' + longitude );
                    this.defaultCoord = {lat: latitude, lng: longitude};

                    this.getPanoramaByLocation(this.defaultCoord);
                });

                this.panorama = new google.maps.StreetViewPanorama(
                    this.panoDiv, {
                        position: this.defaultCoord,
                        pov: {
                            heading: 34,
                            pitch: 10
                        }
                    });
                this.map.setStreetView(this.panorama);

                this.panorama.addListener('pano_changed', () => {
                    this.location = {latLng: {lat: () => this.defaultCoord.lat, lng: () => this.defaultCoord.lng}, pano: this.panorama.getPano()};
                });

                if(detectBrowser.isFirefox) this.containerDiv.style.height = document.querySelector('#e3-viewer-modal').offsetHeight - 70;
            });
        })
    }

    initSearchBox(google){
        var input = this.inputDiv;
        var searchBox = new google.maps.places.SearchBox(input);

        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

        this.map.addListener('bounds_changed', function() {
            searchBox.setBounds(this.map.getBounds());
        }.bind(this));

        var markers = [];
        searchBox.addListener('places_changed', () => {
            var places = searchBox.getPlaces();

            if (places.length == 0) {
                return;
            }

            markers.forEach((marker) => {
                marker.setMap(null);
            });
            markers = [];

            var bounds = new google.maps.LatLngBounds();
            places.forEach((place) => {
                if (!place.geometry) {
                    console.log("Returned place contains no geometry");
                    return;
                }
                var icon = {
                    url: place.icon,
                    size: new google.maps.Size(71, 71),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(25, 25)
                };

                markers.push(new google.maps.Marker({
                    map: this.map,
                    icon: icon,
                    title: place.name,
                    position: place.geometry.location
                }));

                var latitude = place.geometry.location.lat();
                var longitude = place.geometry.location.lng();
                console.log( latitude + ', ' + longitude );
                this.defaultCoord = {lat: latitude, lng: longitude};

                this.getPanoramaByLocation(this.defaultCoord);

                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });
            this.map.fitBounds(bounds);
        });
    }

    getPanoramaByLocation(coords) {
        this.sv.getPanoramaByLocation(coords, 1000, this.processSVData.bind(this));
    }

    processSVData(data, status) {
        if (status == google.maps.StreetViewStatus.OK) {
            this.buttonDiv.disabled = false;
            this.location = data.location;
            this.panorama.setPano(data.location.pano);
            this.panorama.setPov({
                heading: 270,
                pitch: 0
            });
            this.panorama.setVisible(true);
        } else {
            alert('Street View data not found for this location.');
        }
    }


}

export default E3GoogleMap;
